'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRootProperty = exports.getProxy = exports.setConfigAxios = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setConfigAxios = exports.setConfigAxios = function setConfigAxios(config, proxy) {
  var url = proxy.url,
      method = proxy.method,
      headers = proxy.headers,
      params = proxy.params;

  config.url = url;
  config.method = method || 'GET';
  config.headers = headers;
  if (method && method.toLowerCase() === 'post') {
    config.data = params || {};
  } else {
    config.params = params || {};
  }
};

var getProxy = exports.getProxy = function getProxy(props) {
  var proxy = props.proxy,
      url = props.url;

  return proxy || url;
};

var getRootProperty = exports.getRootProperty = function getRootProperty(props) {
  var rootProperty = props.rootProperty;

  var proxy = getProxy(props);
  return _lodash2.default.get(proxy, "rootProperty") || rootProperty || 'data.results';
};